import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const salaryBracketsQuery = gql`
  query GetSalaryBracketsData {
    salaryBrackets {
      id
      description
      __typename
    }
  }
`
export const getSalaryBracketsQueryKey = getQueryNames(salaryBracketsQuery)[0]
export {salaryBracketsQuery}
